import React, { useState } from "react";
import api from "@/lib/api";
import { PeopleListModal } from "@/components/social/PeopleListModal";

/** "N mutual friends" — plain text when 0, otherwise a link that opens the modal. */
export function MutualFriendsLink({ targetUserId, targetName, count, className = "" }) {
  const [open, setOpen] = useState(false);
  const label = `${count.toLocaleString()} mutual friend${count === 1 ? "" : "s"}`;
  const loadIds = async () => (await api.get(`/network/mutual/${targetUserId}`)).data.mutual_user_ids;
  if (!count) return <span className={`text-muted-foreground ${className}`} data-testid="mutual-friends-link">{label}</span>;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={`font-[560] text-primary hover:underline ${className}`} data-testid="mutual-friends-link">{label}</button>
      {open && (
        <PeopleListModal
          open={open}
          onOpenChange={setOpen}
          title={<>Mutual friends{targetName ? <> with <span className="text-primary">{targetName}</span></> : ""}</>}
          count={count}
          loadIds={loadIds}
          noun="mutual friend"
          nounPlural="mutual friends"
        />
      )}
    </>
  );
}
